export default {"src":"/_next/static/media/InternalMed.df996f62.svg","height":91,"width":90,"blurWidth":0,"blurHeight":0};